import React from 'react';
import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';


function NbaReaccreditation() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        NBA Accreditation
                                    </h2>
                                    <div className='pb-2'>
                                        <p>
                                            We are proud to announce that Sridevi Women's Engineering College got re-accredited for the third time by NBA from 2025-26 to 2027-28 for all eligible engineering programs.
                                        </p>

                                    </div>

                                    <div class="spotlight-group">
                                        <div class="row">

                                            <div class="col-md-4 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/1.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/1.jpeg" alt="Image 1" class="img-responsive center-block" />
                                                </a>
                                            </div>

                                            <div class="col-md-4 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/2.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/2.jpeg" alt="Image 2" class="img-responsive center-block" />
                                                </a>
                                            </div>

                                            <div class="col-md-4 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/3.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/3.jpeg" alt="Image 3" class="img-responsive center-block" />
                                                </a>
                                            </div>

                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/4.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/4.jpeg" alt="Image 4" class="img-responsive center-block" />
                                                </a>
                                            </div>

                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/5.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/5.jpeg" alt="Image 5" class="img-responsive center-block" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/1000283476.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/1000283476.jpg" alt="Image 5" class="img-responsive center-block" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/1000283452.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/nba-accreditation-announcement/1000283452.jpg" alt="Image 5" class="img-responsive center-block" />
                                                </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default NbaReaccreditation
